import _objectWithoutProperties from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { interceptConnections } from '../helpers/intercept-connections';
export var createNativeStereoPannerNodeFakerFactory = function createNativeStereoPannerNodeFakerFactory(createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeGainNode, createNativeWaveShaperNode, createNotSupportedError) {
  // The curve has a size of 14bit plus 1 value to have an exact representation for zero. This value has been determined experimentally.
  var CURVE_SIZE = 16385;
  var DC_CURVE = new Float32Array([1, 1]);
  var HALF_PI = Math.PI / 2;
  var SINGLE_CHANNEL_OPTIONS = {
    channelCount: 1,
    channelCountMode: 'explicit',
    channelInterpretation: 'discrete'
  };

  var SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS = _objectSpread({}, SINGLE_CHANNEL_OPTIONS, {
    oversample: 'none'
  });

  var buildInternalGraphForMono = function buildInternalGraphForMono(nativeContext, inputGainNode, panGainNode, channelMergerNode) {
    var leftWaveShaperCurve = new Float32Array(CURVE_SIZE);
    var rightWaveShaperCurve = new Float32Array(CURVE_SIZE);

    for (var i = 0; i < CURVE_SIZE; i += 1) {
      var x = i / (CURVE_SIZE - 1) * HALF_PI;
      leftWaveShaperCurve[i] = Math.cos(x);
      rightWaveShaperCurve[i] = Math.sin(x);
    }

    var leftGainNode = createNativeGainNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_OPTIONS, {
      gain: 0
    })); // Bug #119: Safari does not fully support the WaveShaperNode.

    var leftWaveShaperNode = createNativeWaveShaperNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS, {
      curve: leftWaveShaperCurve
    })); // Bug #119: Safari does not fully support the WaveShaperNode.

    var panWaveShaperNode = createNativeWaveShaperNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS, {
      curve: DC_CURVE
    }));
    var rightGainNode = createNativeGainNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_OPTIONS, {
      gain: 0
    })); // Bug #119: Safari does not fully support the WaveShaperNode.

    var rightWaveShaperNode = createNativeWaveShaperNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS, {
      curve: rightWaveShaperCurve
    }));
    inputGainNode.connect(leftGainNode);
    inputGainNode.connect(panWaveShaperNode.inputs[0]);
    inputGainNode.connect(rightGainNode);
    panWaveShaperNode.connect(panGainNode);
    panGainNode.connect(leftWaveShaperNode.inputs[0]);
    panGainNode.connect(rightWaveShaperNode.inputs[0]);
    leftWaveShaperNode.connect(leftGainNode.gain);
    rightWaveShaperNode.connect(rightGainNode.gain);
    leftGainNode.connect(channelMergerNode, 0, 0);
    rightGainNode.connect(channelMergerNode, 0, 1);
    return [leftGainNode, rightGainNode];
  };

  var buildInternalGraphForStereo = function buildInternalGraphForStereo(nativeContext, inputGainNode, panGainNode, channelMergerNode) {
    var leftInputForLeftOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
    var leftInputForRightOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
    var rightInputForLeftOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
    var rightInputForRightOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
    var centerIndex = Math.floor(CURVE_SIZE / 2);

    for (var i = 0; i < CURVE_SIZE; i += 1) {
      if (i > centerIndex) {
        var x = (i - centerIndex) / (CURVE_SIZE - 1 - centerIndex) * HALF_PI;
        leftInputForLeftOutputWaveShaperCurve[i] = Math.cos(x);
        leftInputForRightOutputWaveShaperCurve[i] = Math.sin(x);
        rightInputForLeftOutputWaveShaperCurve[i] = 0;
        rightInputForRightOutputWaveShaperCurve[i] = 1;
      } else {
        var _x = i / (CURVE_SIZE - 1 - centerIndex) * HALF_PI;

        leftInputForLeftOutputWaveShaperCurve[i] = 1;
        leftInputForRightOutputWaveShaperCurve[i] = 0;
        rightInputForLeftOutputWaveShaperCurve[i] = Math.cos(_x);
        rightInputForRightOutputWaveShaperCurve[i] = Math.sin(_x);
      }
    }

    var channelSplitterNode = createNativeChannelSplitterNode(nativeContext, {
      channelCount: 2,
      channelCountMode: 'explicit',
      channelInterpretation: 'discrete',
      numberOfOutputs: 2
    });
    var leftInputForLeftOutputGainNode = createNativeGainNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_OPTIONS, {
      gain: 0
    })); // Bug #119: Safari does not fully support the WaveShaperNode.

    var leftInputForLeftOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS, {
      curve: leftInputForLeftOutputWaveShaperCurve
    }));
    var leftInputForRightOutputGainNode = createNativeGainNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_OPTIONS, {
      gain: 0
    })); // Bug #119: Safari does not fully support the WaveShaperNode.

    var leftInputForRightOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS, {
      curve: leftInputForRightOutputWaveShaperCurve
    })); // Bug #119: Safari does not fully support the WaveShaperNode.

    var panWaveShaperNode = createNativeWaveShaperNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS, {
      curve: DC_CURVE
    }));
    var rightInputForLeftOutputGainNode = createNativeGainNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_OPTIONS, {
      gain: 0
    })); // Bug #119: Safari does not fully support the WaveShaperNode.

    var rightInputForLeftOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS, {
      curve: rightInputForLeftOutputWaveShaperCurve
    }));
    var rightInputForRightOutputGainNode = createNativeGainNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_OPTIONS, {
      gain: 0
    })); // Bug #119: Safari does not fully support the WaveShaperNode.

    var rightInputForRightOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, _objectSpread({}, SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS, {
      curve: rightInputForRightOutputWaveShaperCurve
    }));
    inputGainNode.connect(channelSplitterNode);
    inputGainNode.connect(panWaveShaperNode.inputs[0]);
    channelSplitterNode.connect(leftInputForLeftOutputGainNode, 1);
    channelSplitterNode.connect(leftInputForRightOutputGainNode, 1);
    channelSplitterNode.connect(rightInputForLeftOutputGainNode, 1);
    channelSplitterNode.connect(rightInputForRightOutputGainNode, 1);
    panWaveShaperNode.connect(panGainNode);
    panGainNode.connect(leftInputForLeftOutputWaveShaperNode.inputs[0]);
    panGainNode.connect(leftInputForRightOutputWaveShaperNode.inputs[0]);
    panGainNode.connect(rightInputForLeftOutputWaveShaperNode.inputs[0]);
    panGainNode.connect(rightInputForRightOutputWaveShaperNode.inputs[0]);
    leftInputForLeftOutputWaveShaperNode.connect(leftInputForLeftOutputGainNode.gain);
    leftInputForRightOutputWaveShaperNode.connect(leftInputForRightOutputGainNode.gain);
    rightInputForLeftOutputWaveShaperNode.connect(rightInputForLeftOutputGainNode.gain);
    rightInputForRightOutputWaveShaperNode.connect(rightInputForRightOutputGainNode.gain);
    leftInputForLeftOutputGainNode.connect(channelMergerNode, 0, 0);
    rightInputForLeftOutputGainNode.connect(channelMergerNode, 0, 0);
    leftInputForRightOutputGainNode.connect(channelMergerNode, 0, 1);
    rightInputForRightOutputGainNode.connect(channelMergerNode, 0, 1);
    return [leftInputForLeftOutputGainNode, rightInputForLeftOutputGainNode, leftInputForRightOutputGainNode, rightInputForRightOutputGainNode];
  };

  var buildInternalGraph = function buildInternalGraph(nativeContext, channelCount, inputGainNode, panGainNode, channelMergerNode) {
    if (channelCount === 1) {
      return buildInternalGraphForMono(nativeContext, inputGainNode, panGainNode, channelMergerNode);
    }

    if (channelCount === 2) {
      return buildInternalGraphForStereo(nativeContext, inputGainNode, panGainNode, channelMergerNode);
    }

    throw createNotSupportedError();
  };

  return function (nativeContext, _ref) {
    var channelCount = _ref.channelCount,
        channelCountMode = _ref.channelCountMode,
        pan = _ref.pan,
        audioNodeOptions = _objectWithoutProperties(_ref, ["channelCount", "channelCountMode", "pan"]);

    if (channelCountMode === 'max') {
      throw createNotSupportedError();
    }

    var channelMergerNode = createNativeChannelMergerNode(nativeContext, _objectSpread({}, audioNodeOptions, {
      channelCount: 1,
      channelCountMode: channelCountMode,
      numberOfInputs: 2
    }));
    var inputGainNode = createNativeGainNode(nativeContext, _objectSpread({}, audioNodeOptions, {
      channelCount: channelCount,
      channelCountMode: channelCountMode,
      gain: 1
    }));
    var panGainNode = createNativeGainNode(nativeContext, {
      channelCount: 1,
      channelCountMode: 'explicit',
      channelInterpretation: 'discrete',
      gain: pan
    });
    var outputNodes = buildInternalGraph(nativeContext, channelCount, inputGainNode, panGainNode, channelMergerNode);
    Object.defineProperty(panGainNode.gain, 'defaultValue', {
      get: function get() {
        return 0;
      }
    });
    var nativeStereoPannerNodeFakerFactory = {
      get bufferSize() {
        return undefined;
      },

      get channelCount() {
        return inputGainNode.channelCount;
      },

      set channelCount(value) {
        if (inputGainNode.channelCount !== value) {
          inputGainNode.disconnect();
          outputNodes.forEach(function (outputNode) {
            return outputNode.disconnect();
          });
          outputNodes = buildInternalGraph(nativeContext, value, inputGainNode, panGainNode, channelMergerNode);
        }

        inputGainNode.channelCount = value;
      },

      get channelCountMode() {
        return inputGainNode.channelCountMode;
      },

      set channelCountMode(value) {
        if (value === 'clamped-max' || value === 'max') {
          throw createNotSupportedError();
        }

        inputGainNode.channelCountMode = value;
      },

      get channelInterpretation() {
        return inputGainNode.channelInterpretation;
      },

      set channelInterpretation(value) {
        inputGainNode.channelInterpretation = value;
      },

      get context() {
        return inputGainNode.context;
      },

      get inputs() {
        return [inputGainNode];
      },

      get numberOfInputs() {
        return inputGainNode.numberOfInputs;
      },

      get numberOfOutputs() {
        return inputGainNode.numberOfOutputs;
      },

      get pan() {
        return panGainNode.gain;
      },

      addEventListener: function addEventListener() {
        return inputGainNode.addEventListener(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
      },
      dispatchEvent: function dispatchEvent() {
        return inputGainNode.dispatchEvent(arguments.length <= 0 ? undefined : arguments[0]);
      },
      removeEventListener: function removeEventListener() {
        return inputGainNode.removeEventListener(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
      }
    };
    return interceptConnections(nativeStereoPannerNodeFakerFactory, channelMergerNode);
  };
};